<template>
  <div class="has-partner-component">
    <div class="column is-12">
      <div class="columns">
        <div class="column is-full">
          <p class="is-size-1 has-text-centered has-text-grey-dark dm-sans">
            Qual plano você gostaria?
          </p>
        </div>
      </div>
      <div class="columns mt-6">
        <div class="column is-one-third" v-for="(plan, index) in filteredPlans" :key="index">
          <div class="is-flex is-justify-content-center is-full">
            <div
                class="box is-size-3 mx-4 p-6 is-fullwidth has-text-centered"
            >
              <div class="columns">
                <div class="column is-12">
                  <h1 class="is-size-2 has-text-weight-bold">
                    {{ plan.name }}
                  </h1>
                </div>
              </div>
              <div class="columns">
                <div class="column is-full is-flex is-justify-content-center">
                  <div class="is-fit-width">
                    <span class="has-text-grey-dark is-size-6 is-desktop is-pulled-left">R$</span>
                    <span class="is-size-2 has-text-weight-semibold has-text-black">
                      {{ formatPrice(plan.price) }}
                    </span>
                    <span class="has-text-grey-dark is-size-6">/MÊS</span>
                  </div>
                </div>
              </div>
              <div class="columns">
                <div class="column is-full">
                  <div>
                    <span class="has-text-grey-dark is-size-5">
                      {{ plan.max_accesses }} acessos
                    </span>
                  </div>
                </div>
              </div>
              <div class="columns">
                <div class="column is-full">
                  <div>
                    <span class="has-text-grey-dark is-size-5">
                      R$ {{ formatPrice(plan.price * 12) }} por ano
                    </span>
                    <span v-if="plan.discount_percentage" class="tag is-primary is-small is-size-6">
                      DESCONTO DE {{ plan.discount_percentage }}%
                    </span>
                    <span v-else class="tag is-primary is-small is-size-6">
                      SEM DESCONTO
                    </span>
                  </div>
                </div>
              </div>
              <div class="columns">
                <div class="column is-full">
                  <button
                      class="button is-primary is-size-5 is-medium has-text-weight-medium is-four-fifths"
                      @click.prevent="choosePlan(plan)"
                  >
                    <div class="is-fullwidth">
                      Quero este
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import plans from '@/apis/plans'

export default {

  name: 'plans',

  data() {
    return {
      plans: []
    }
  },

  props: {
    formData: {
      required: true,
      type: Object
    }
  },

  computed: {
    filteredPlans() {
      const plans = []
      if (this.formData.partner.data.id) {
        for (const plan of this.plans) {
          if (plan.partners.length > 0) {
            plans.push(plan)
          }
        }
      } else {
        for (const plan of this.plans) {
          if (plan.partners.length === 0) {
            plans.push(plan)
          }
        }
      }
      return plans
    }
  },

  methods: {
    async getPlans() {
      this.plans = await plans.get(this.formData.integration.data.type)
    },
    cleanData() {
      this.plans = []
      this.formData.integration.data.type = null
    },
    formatPrice(value) {
      return (parseFloat(value).toLocaleString('pt-BR', { currency: 'BRL', style: 'currency' }))
          .replace('R$', '').trim();
    },
    choosePlan(plan) {
      this.formData.plan.showStep = true
      this.formData.plan.data = plan
      this.$emit('nextTab')
    }

  }

}

</script>

<style lang="scss" scoped>
$box-color: #000;
</style>